// extracted by mini-css-extract-plugin
module.exports = {"vGray3":"#dfe1fa","desktop-up":"(min-width: calc(1280 * 1px))","row":"TableListRow_row__1U8C0"};